import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { BENEFITS } from "@/lib/marketing-constants";

interface CalloutProps {
  className?: string;
  label?: string;
}

/**
 * Callout: a single quiet row of what you get, directly under the hero.
 *
 * One line where it fits, and it wraps into two centred rows rather than
 * stretching a six-item list across the full page width — the earlier
 * version did, and the hairline separators then landed in the middle of
 * a wrapped line.
 */
export function Callout({ className, label = "What you get" }: CalloutProps) {
  return (
    <section
      aria-label={label}
      className={cn("border-b border-border/60 bg-background", className)}
    >
      <div className="container mx-auto max-w-6xl px-4 py-7">
        <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-center sm:gap-6">
          <span className="shrink-0 text-[11px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">
            {label}
          </span>
          <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            {BENEFITS.map((benefit) => (
              <li
                key={benefit}
                className="flex items-center gap-1.5 text-sm text-muted-foreground"
              >
                <Check
                  className="h-3.5 w-3.5 text-primary"
                  aria-hidden="true"
                />
                {benefit}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
